<script >
import {getCurrentInstance, onMounted, ref} from 'vue'
// const extras = ref({});

export default {
  name: 'Option',
  props: ['step', 'product', 'productsize', 'type','quantity'],
  inject: ['t','localeState'],
  data() {
    return {
      extras: [],
      extras2: [],
      gift: false,
      qty: [],
      quantity: [],
      isLoading: false,
      rahmenStock: false,
      giftImg: false,
      product: [],
      equipmentSetProduct: null,
      extrasUrl: [
          'https://picmondoo.de/products/mehr-farben-fur-personalisierte-diamond-paintings.json',
          'https://picmondoo.de/products/glitzersteine-ab-fur-personalisierte-diamond-paintings.json',
          'https://picmondoo.de/products/leuchtsteine-fur-personalisierte-diamond-paintings.json',
          'https://picmondoo.de/products/feenstaubeffekt.json',
          'https://picmondoo.de/products/metalliceffekt.json',
          'https://picmondoo.de/products/strasseffekt.json',
        ],
        extras2Url: [
          'https://picmondoo.de/products/equipment-set.json',
          'https://picmondoo.de/products/farbtabelle-als-aufkleber.json',
          'https://picmondoo.de/products/cover-minder-personalisiert.json',
          'https://picmondoo.de/products/aufkleber-5er-set.json',
          'https://picmondoo.de/products/profidatencheck.json',
          'https://picmondoo.de/products/bevorzugte-produktion.json',
          'https://picmondoo.de/products/geschenkverpackung-1.json',
          'https://picmondoo.de/products/diamond-painting-bilderrahmen-schwarz-6-grossen-plexi.json',
      ]
    }
  },
  mounted() {

    if(this.$props.type !== '8341420540169') {
      this.extras2Url = [];
      return;
    }

    this.extrasUrl.forEach((element,key) => this.getExtras(element,key));
    this.extras2Url.forEach((element,key) => this.getExtras2(element,key));

  },
  watch: {
    step(newStep) {
      // Auto-select Equipment Set when reaching step 3
      if (newStep === 3 && this.equipmentSetProduct && !this.isExtraSelected(this.equipmentSetProduct)) {
        console.log('Step 3 reached, auto-selecting Equipment Set');
        this.$nextTick(() => {
          this.addToProduct(this.equipmentSetProduct);
          console.log('Equipment Set auto-selected on step 3');
        });
      }
    }
  },
  methods: {
    fetchShopifyProducts: async function(id) {
      try {
        const API_KEY = "40a4d90f0da706f03c1bc4e747628e85";
        const PASSWORD = "16256bf9b99e7ce75b5e952a29db1024";

        const url = `https://picmondoo.myshopify.com/admin/api/2024-01/products/`+id+`.json`;

        const headers = new Headers({
          "Authorization": `Basic ${btoa(`${API_KEY}:${PASSWORD}`)}`,
          "Content-Type": "application/json",
        });

        const options = {
          method: "GET",
          headers,
          mode: "cors",
        };

        fetch(url, options)
            .then((response) => response.json())
            .then((data) => {
              console.log(data);
            })
            .catch((error) => {
              console.error(error);
            });
      } catch (error) {
        console.error("Error fetching Shopify products:", error);
      }
    },
    getStock: async function(id) {
      try {
        const url = 'https://querytag.de/projekte/picmondoo/shopify/?id=' + id;
        console.log(url);

        const response = await fetch(url, {
          method: 'GET'
        });

        if (!response.ok) {
          throw new Error('Netzwerkantwort war nicht ok');
        }

        this.rahmenStock = await response.json();

      } catch (error) {
        console.error('Fehler beim Abrufen der Daten:', error);
        throw error; // Optional: Weiterwerfen des Fehlers für die Fehlerbehandlung im Aufrufer
      }
    },
    getExtras: function (url,key) {
      fetch(url, {
        method: 'GET' //optional
      })
          .then(async (response) => {
            response = await response.json()
            this.extras[key] = response.product;
          })
          .catch((error) => {
            return error
          })
    },
    getExtras2: async function (url, key) {
      fetch(url, {
        method: 'GET' //optional
      })
          .then(async (response) => {
            response = await response.json()
            // await this.getStock(response.product.id);
            this.extras2[key] = response.product;


            if (response.product.title && response.product.title.includes('Equipment Set')) {
              console.log('Equipment Set found, storing for auto-selection');
              // Store the Equipment Set for auto-selection when step 3 is reached
              this.equipmentSetProduct = response.product;
            }
          })
          .catch((error) => {
            return error
          })
    },
    getIndexForArea(size) {
      size = size.replace('cm','');
      size = size.split('x');
      let area = size[0]*size[1];

      if (area <= 1000) return 0;
      if (area <= 2500) return 1;
      if (area <= 6400) return 2;
      return 3;
    },
    getBilderRahmen(extra) {
      let size = this.$props.productsize;
      let extraIndex;
      
      if (!extra || !extra.variants) {
        return undefined;
      }
      
      size = size.replace('cm','');
      size = size.split('x');

      extra.variants.forEach((variant, index) => {
        if(variant.title.includes(size[0]+'x'+size[1]) || variant.title.includes(size[1]+'x'+size[0])) {

          extraIndex = index;
          // this.fetchShopifyProducts(variant.id)
        }
      })

      return extraIndex;
    },
    addGiftToProduct(id) {
      this.product[this.step - 2] = this.product[this.step - 2] || [];
      this.product[this.step - 2]['geschenk'] = id;

      if (this.extras2[2] && this.extras2[2].images) {
        this.extras2[2].images.forEach((image) => {
          if (image.variant_ids[0] === id) {
            this.giftImg = image.src;
          }
        });
      }
    },

    checkGiftProduct(extra) {
      if (!extra) {
        return;
      }
      if (this.product[this.step - 2] && this.product[this.step - 2]['geschenk']) {
        delete this.product[this.step - 2]['geschenk'];
      }
    },
    addQtyProduct(extra,qty) {
      if (!extra) {
        return;
      }
      this.addToProduct(extra);
      let extraIndex = this.getIndexForArea(this.$props.productsize);
      // Check if the variant exists at the calculated index
      if (!extra.variants || !extra.variants[extraIndex]) {
        return;
      }
      const productId = extra.variants[extraIndex].id;
      this.quantity[productId] = qty;
      const index = (this.product[this.step - 2] || []).indexOf(productId);

      if (index === -1) {
        this.product[this.step - 2] = this.product[this.step - 2] || [];
        this.product[this.step - 2].push(productId);
      }
    },
    addToProduct(extra) {
      if (!extra) {
        return;
      }
      if (this.step === 2) {
        if(!this.qty[extra.id]) {
          this.qty[extra.id] = 1;
        }
        let extraIndex = this.getIndexForArea(this.$props.productsize);
        // Check if the variant exists at the calculated index
        if (!extra.variants || !extra.variants[extraIndex]) {
          return;
        }
        const productId = extra.variants[extraIndex].id;
        const index = (this.product[this.step - 2] || []).indexOf(productId);

        if (index === -1) {
          this.product[this.step - 2] = this.product[this.step - 2] || [];
          this.product[this.step - 2].push(productId);
        } else {
          this.product[this.step - 2].splice(index, 1);
        }
      } else {
        let index;

        if (extra.title === 'Geschenkverpackung') {
          return;
        }

        if (!extra.variants || extra.variants.length === 0) {
          return;
        }

        if (extra.title === 'Diamond Painting Bilderrahmen aus Aluminium - (12 Größen) PLEXI') {
          index = this.getBilderRahmen(extra);
          if (index === undefined || !extra.variants[index]) {
            return;
          }
          let indexArray = (this.product[this.step - 2] || []).indexOf(extra.variants[index].id);

          if (indexArray === -1) {
            this.product[this.step - 2] = this.product[this.step - 2] || [];
            this.product[this.step - 2].push(extra.variants[index].id);
          } else {
            this.product[this.step - 2].splice(indexArray, 1);
          }

          return;
        }

        if (!extra.variants[0]) {
          return;
        }

        index = (this.product[this.step - 2] || []).indexOf(extra.variants[0].id);

        if (index === -1) {
          this.product[this.step - 2] = this.product[this.step - 2] || [];
          this.product[this.step - 2].push(extra.variants[0].id);
        } else {
          this.product[this.step - 2].splice(index, 1);
        }
      }
    },
    isExtraSelected(extra) {
      if(!extra || extra.title === 'Geschenkverpackung' ) {
        return;
      }
      if(this.step == 2) {
        let extraIndex = this.getIndexForArea(this.$props.productsize);
        // Check if the variant exists at the calculated index
        if (!extra.variants || !extra.variants[extraIndex]) {
          return false;
        }
        const productId = extra.variants[extraIndex].id;
        return (this.product[this.step - 2] || []).includes(productId);
      } else {
        if (!extra.variants || extra.variants.length === 0) {
          return false;
        }
        
        if(extra.title == 'Diamond Painting Bilderrahmen aus Aluminium - (12 Größen) PLEXI') {
          let rahmenIndex = this.getBilderRahmen(extra);
          if(rahmenIndex !== undefined && extra.variants[rahmenIndex]) {
            return (this.product[this.step - 2] || []).includes(extra.variants[rahmenIndex].id);
          } else if (extra.variants[0]) {
            return (this.product[this.step - 2] || []).includes(extra.variants[0].id);
          }

        } else {
          if (extra.variants[0]) {
            return (this.product[this.step - 2] || []).includes(extra.variants[0].id);
          }
        }
        
        return false;

      }

    },
    generatePercentAll: function (compare_price, price) {
      let allPercent = 0;
      allPercent = 100 - ((100 / compare_price) * price);
      allPercent = (allPercent).toFixed(0)

      if (isNaN(allPercent)) {
        return '';
      }
      return allPercent;
    },
    getSafeVariant(extra) {
      if (!extra || !extra.variants) return null;
      let extraIndex = this.getIndexForArea(this.$props.productsize);
      return extra.variants[extraIndex] || null;
    },
    formatPrice(value) {
      if (value === undefined || value === null || value === '') {
        return '';
      }
      const localeKey = this.localeState?.locale?.value || this.localeState?.locale || 'de';
      const map = {
        en: 'en-US',
        fr: 'fr-FR',
        de: 'de-DE'
      };
      const activeLocale = map[typeof localeKey === 'string' ? localeKey : 'de'] || 'de-DE';
      return Number(value).toLocaleString(activeLocale);
    }
  }
}

</script>

<template>
  <div v-if="step == 2" class="roundBox extraBox">
    <button class="backBtn" @click="$emit('step-back')"> {{ t('edit') }} </button>
    <h4>{{ t('extrasTitle') }}</h4>
    <template v-for="(extra) in extras" :key="extra?.id">
      <div v-if="extra && getSafeVariant(extra)" class="extras" @click="addToProduct(extra)" :class="{ 'extras': true, 'active': isExtraSelected(extra) }">
        <div >
          <b>{{ extra.title }}</b>
          <span class="price">{{ Number(getSafeVariant(extra).price) === 0 ? t('free') : formatPrice(getSafeVariant(extra).price) + '€' }}</span>
          <span class="old_price" v-if="getSafeVariant(extra).compare_at_price > 0">{{ formatPrice(getSafeVariant(extra).compare_at_price) }}€</span>
          <div style="display: inline-flex;align-items: center;gap: 4px;">
            <span class="percent" v-if="getSafeVariant(extra).compare_at_price > 0">{{ generatePercentAll(getSafeVariant(extra).compare_at_price, getSafeVariant(extra).price) }} %</span>
            <span class="chip" v-if="extra.title.includes('Cover Minder') || extra.title.includes('Equipment Set') || extra.title.includes('Farbtabelle als Aufkleber') || extra.title.includes('Aufkleber 5er-Set')">{{ t('new') }}</span>
          </div>
          <p v-html="extra.body_html"></p>
          <template v-if="extra.title !== 'Mehr Farben' && extra.title !== 'Cover Minder'">
            <span>{{ t('amount') }}: </span>
            <select name="qty" id="qty-select" @change="addQtyProduct(extra, qty[extra.id])" @click.stop="addQtyProduct(extra, qty[extra.id])" v-model="qty[extra.id]" >
              <option v-for="index in 10" :key="index" :value="index"> {{ index }}
                <template  v-if="index == 1" >{{ t('colorSingular') }}</template>
                <template v-else> {{ t('colorPlural') }}</template>
              </option>
            </select>
          </template>
        </div>
        <div>
          <img :src="extra.image.src">
        </div>
      </div>
    </template>
    <div class="ctaWrapper">
      <button class="cta" @click="$emit('next-step')"> {{ t('next') }}</button>
    </div>
  </div>
  <div v-else-if="step == 3" class="roundBox extraBox step3">
    <button class="backBtn" @click="$emit('step-back')" v-if="this.$props.type === '8341420540169'"> {{ t('extras') }}</button>
    <button class="backBtn" @click="$emit('step-back')" v-else> {{ t('edit') }}</button>
    <h4 v-if="this.$props.type === '8341420540169'">{{ t('serviceTitle') }}</h4>
    <template v-for="(extra) in extras2" :key="extra?.id">
      <div @click="addToProduct(extra)" class="extras" :class="{ 'extras': true, 'active': isExtraSelected(extra) }" v-if="extra && extra.variants && extra.variants[0] && extra.title !== 'Geschenkverpackung' && extra.handle !== 'diamond-painting-bilderrahmen-schwarz-6-grossen-plexi'" >
        <div>
          <b>{{ extra.title }}</b>
          <span class="price">{{ Number(extra.variants[0].price) === 0 ? t('free') : formatPrice(extra.variants[0].price) + '€' }}</span>
          <span class="old_price" v-if="extra.variants[0].compare_at_price > 0">{{ formatPrice(extra.variants[0].compare_at_price)  }}€</span>
          <div style="display: inline-flex;align-items: center;gap: 4px;">
            <span class="percent" v-if="extra.variants[0].compare_at_price > 0">{{ generatePercentAll(extra.variants[0].compare_at_price,extra.variants[0].price) }} %</span>
            <span class="chip" v-if="extra.title.includes('Cover Minder') || extra.title.includes('Equipment Set') || extra.title.includes('Farbtabelle als Aufkleber') || extra.title.includes('Aufkleber 5er-Set')">{{ t('new') }}</span>
          </div>
          <p v-html="extra.body_html"></p>
        </div>
        <div v-if="extra.handle === 'diamond-painting-bilderrahmen-schwarz-6-grossen-plexi' && extra.variants[getBilderRahmen(extra)]">
          <b>Bilderrahmen - {{ extra.variants[getBilderRahmen(extra)].title }}</b>
          <span class="price">{{ Number(extra.variants[getBilderRahmen(extra)].price) === 0 ? t('free') : formatPrice(extra.variants[getBilderRahmen(extra)].price) + '€' }}</span>
          <span class="old_price" v-if="extra.variants[getBilderRahmen(extra)].compare_at_price > 0">{{ formatPrice(extra.variants[getBilderRahmen(extra)].compare_at_price)  }}€</span>
          <div style="display: inline-flex;align-items: center;gap: 4px;">
            <span class="percent" v-if="extra.variants[getBilderRahmen(extra)].compare_at_price > 0">{{ generatePercentAll(extra.variants[getBilderRahmen(extra)].compare_at_price,extra.variants[0].price) }} %</span>
            <span class="chip" v-if="extra.title.includes('Cover Minder') || extra.title.includes('Equipment Set') || extra.title.includes('Farbtabelle als Aufkleber') || extra.title.includes('Aufkleber 5er-Set')">{{ t('new') }}</span>
          </div>
        </div>
        <div v-if="extra.title !== 'Geschenkverpackung'">
          <img :src="extra.image.src">
        </div>
      </div>
      <div  v-if="extra && extra.variants && extra.variants[0] && extra.title === 'Geschenkverpackung'" @click="checkGiftProduct(extra)"  class="extras test" :class="{ 'extras': true, 'active': product[step - 2]?.geschenk }">
        <div>
          <b>{{ extra.title }}</b>
          <span class="price">{{ Number(extra.variants[0].price) === 0 ? t('free') : formatPrice(extra.variants[0].price) + '€' }}</span>
          <span class="old_price" v-if="extra.variants[0].compare_at_price > 0">{{ formatPrice(extra.variants[0].compare_at_price)  }}€</span>
          <div style="display: inline-flex;align-items: center;gap: 4px;">
            <span class="percent" v-if="extra.variants[0].compare_at_price > 0">{{ generatePercentAll(extra.variants[0].compare_at_price,extra.variants[0].price) }} %</span><br>
          </div>
          <select name="gift" id="gift-select" @change="addGiftToProduct(gift)" @click.stop="addGiftToProduct(gift)" v-model="gift">
            <option v-for="(varianten) in extra.variants" :value="varianten.id">{{varianten.title}}</option>
          </select>
          <p v-html="extra.body_html"></p>
          <br>
        </div>
        <div>
          <img v-if="giftImg" :src="giftImg" >
          <img v-else :src="extra.image.src" >
        </div>
      </div>
      <div v-if="extra && $props.type === '8341420540169'&& extra.variants && extra.variants[getBilderRahmen(extra)] && extra.handle === 'diamond-painting-bilderrahmen-schwarz-6-grossen-plexi'" @click="addToProduct(extra)" class="extras" :class="{ 'extras': true, 'active': isExtraSelected(extra), 'hideExtra': !rahmenStock }">
        <div>
          <b>Bilderrahmen - {{ extra.variants[getBilderRahmen(extra)].title }}</b>
          <span class="price">{{ Number(extra.variants[getBilderRahmen(extra)].price) === 0 ? t('free') : formatPrice(extra.variants[getBilderRahmen(extra)].price) + '€' }}</span>
          <span class="old_price" v-if="extra.variants[getBilderRahmen(extra)].compare_at_price > 0">{{ formatPrice(extra.variants[getBilderRahmen(extra)].compare_at_price)  }}€</span>
          <div style="display: inline-flex;align-items: center;gap: 4px;">
            <span class="percent" v-if="extra.variants[getBilderRahmen(extra)].compare_at_price > 0">{{ generatePercentAll(extra.variants[getBilderRahmen(extra)].compare_at_price,extra.variants[0].price) }} %</span>
          </div>
        </div>
        <div>
          <img :src="extra.image.src">
        </div>
      </div>
    </template>
    <div class="ctaWrapper">
      <div class="ctaNewBorder">
        <button class="ctaNew" :class="{ isLoading: isLoading}" @click="$emit('cartandrestart', product,quantity), isLoading = true"> {{ t('addMorePhoto') }} <img src="https://picmondo.de/projekte/generator/dist/assets/img/addIcon.svg"></button>
      </div>
      <button class="cta" :class="{ isLoading: isLoading}" @click="$emit('cart', product,quantity), isLoading = true"> {{ t('addToCart') }} <img src="https://picmondo.de/projekte/generator/dist/assets/img/cartIcon.svg"></button>
    </div>
  </div>
</template>


<style scoped>
.percent {
  background: #EF6461;
  color: #fff;
  border-radius: 50px;
  padding: 1px 5px;
  margin-left: 5px;
}
.extras {
  color: #001761;
  border: 2px solid #CFCECB;
  padding: 10px 20px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 20px;
  align-items: center;
  font-size: 18px;
  border-radius: 15px;
  cursor: pointer;
  width: 100%;
  margin: 0 auto 15px;
}
.extras.extras.hideExtra {
  display: none;
}
.extras.active {
  border: 2px solid #FFB743;
}
.extras b {
  font-weight: 700;
  display: block;
}
.extras.extras b {
  font-size: 10.2pt !important;
  line-height: normal;
  margin-bottom: 0;
}
.extras p {
  font-size: 16px;
  line-height: 19px;
}
.price {
  color: #EF6461;
  margin-right: 10px;
}
.old_price {
  color: #A6A6A6;
  text-decoration: line-through;
}
.roundBox.extraBox {
  height: 93vh;
  max-height: unset;
  position: relative;
}

.roundBox.extraBox .cta {
  position: sticky;
  bottom: 0px;
  left: 20px;
  right: 20px;
  margin-top: 15px;
  width: 100%;
}
button.backBtn {
  background: unset;
  border: none;
  font-size: 13.7pt;
  color: #001761;
  margin-bottom: 14pt;
  font-weight: 700;
}
button.backBtn:before {
  content: '<';
  display: inline-block;
  transform: scale(1, 1.3);
  -webkit-transform: scale(1, 1.3);
  -moz-transform: scale(1, 1.3);
  -ms-transform: scale(1, 1.3);
  -o-transform: scale(1, 1.3);
  font-weight: 500;
  margin-right: 12pt;
}
.roundBox.extraBox h4 {
  color: #001761;
  font-size: 14.7pt;
  font-weight: 700;
  margin-bottom: 18pt;
}
@media (max-width: 560px) {
  .roundBox.extraBox .cta {
    bottom: 0;
    max-height: 40pt;
  }
  .extras.extras b {
    font-size: 8.6pt !important;
  }
  .extras.extras span.price, .extras.extras span.old_price {
    font-size: 8.6pt !important;
  }
  .extras.extras span.percent {
    font-size: 7.4pt!important;
  }
}
</style>
